import { Button, Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { T_Video } from "../../common/model/videoModel";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import apis from "../../common/apis";


export default function VideoInsert(){
    const nav = useNavigate()
    const [data,setData] = useState<T_Video>();

    const {alert,setAlert} = useAlert();
    const saveData = async()=>{
        if(data?.title == undefined){
            setAlert({...alert,title:"확인",visible:true,msg:"제목을 입력해주세요"})
            return;
         }
         if(data?.videoId == undefined){
            setAlert({...alert,title:"확인",visible:true,msg:"videoId를 입력해주세요"})
            return;
         }

         setAlert({
            ...alert,
            visible:true,
            title:"확인",
            msg:"정말로 등록하시겠습니까?",
            buttonList:[{
              variant:"contained",
              text:"예",
              onPress:async()=>{
                setAlert(initialAlert);
                const result = await apis.video.videoCreate(data)
                if(result.code=="1"){
                    setAlert({...alert,title:"확인",visible:true,msg:"저장되었습니다."})
                    nav(-1);
                }else{
                    setAlert({...alert,title:"확인",visible:true,msg:"저장중 오류가 발생했습니다."})
                }
              }
            }
              ,
              {
                text:"아니요",
                variant:"outlined",
                onPress:()=>{
                  setAlert({...alert,visible:false})
                }
              }
            ]
          })         
       

  
    }

    return(
    <Card sx={{p:0}} >
        <CardHeader title="영상 등록" sx={{p:1,mb:0}}/>
        <CardContent sx={{p:1}}>
            <Divider />
            <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2,m:0,p:0
            }} > 
                <TableHead />
                <TableBody>
                    <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          제목
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data?.title || ''} onChange={(event)=>{setData({...data,title:event.target.value})}} />
                        </TableCell>      
                    </TableRow>         
                    <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          비디오ID
                          (YOUTUBE)
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data?.videoId || ''} onChange={(event)=>{setData({...data,videoId:event.target.value})}} />
                        </TableCell>      
                    </TableRow>      
                    <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          내용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data?.contents || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

                    </TableRow>                              
                </TableBody>
            </Table>
        </CardContent>
        <div style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
                <Button variant="contained" onClick={()=>{
                 saveData();
            }}>저장</Button>
                <Button variant="outlined" onClick={()=>{
                nav(-1);
            }}>취소</Button>
        </div>
    </Card>
    )

}